import React from "react";
import { Modal, Button, FormGroup, ControlLabel, FormControl } from "react-bootstrap";
import { lireModele } from "../../store/external/modeles"; // 03/11/2026 (registre n° 38)

export const CALL_DONE_DEFAULT_MESSAGE =
  "Nous avons tenté de vous joindre au sujet de cette demande d'intervention et vous avons laissé un message, resté sans réponse à ce jour.\n" +
  "Merci de nous recontacter afin de convenir d'un rendez-vous.";

/**
 * Confirmation avant de passer une demande en « Message laissé » (statut 7)
 * et d'envoyer le mail d'information aux contacts de la demande.
 * props : show, request, onConfirm(message), onCancel, sending
 */
export default class CallDoneModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = { message: CALL_DONE_DEFAULT_MESSAGE, enLigne: true }; // 04/11/2026 (registre n° 39)
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.show && !this.props.show) {
      this.setState({ message: CALL_DONE_DEFAULT_MESSAGE, touched: false, fromModel: false, enLigne: true });
      // 03/11/2026 : texte repris du modèle commun (Paramètres > Message laissé) ; sinon texte d'origine
      lireModele("message_laisse").then((j) => {
        if (this.props.show && !this.state.touched && j && j.texte) this.setState({ message: j.texte, fromModel: true });
      }).catch(() => { /* modèle indisponible : texte d'origine */ });
    }
  }

  render() {
    const { show, request, onConfirm, onCancel, sending } = this.props;
    const contacts =
      request && request.contacts
        ? request.contacts.map((c) => (typeof c === "string" ? c : c.email)).join(", ")
        : "";
    return (
      <Modal show={show} onHide={onCancel} bsSize="large">
        <Modal.Header closeButton>
          <Modal.Title>
            Message laissé — demande n°{request ? request.numRequest : ""}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {request ? (
            <p>
              <b>{request.name}</b>
              <br />
              <small>Destinataires : {contacts || "aucun contact sur la demande"} (+ copie interventions)</small>
            </p>
          ) : null}
          <FormGroup>
            <ControlLabel>Texte du mail envoyé au client</ControlLabel>
            <FormControl
              componentClass="textarea"
              rows="6"
              value={this.state.message}
              onChange={(e) => this.setState({ message: e.target.value, touched: true })}
            />
            <small style={{ color: "#5d6b7a" }}>
              {this.state.fromModel
                ? "Texte du modèle commun (Paramètres › Message laissé) — une modification ici ne vaut que pour cet envoi."
                : "Le texte proposé se règle dans Paramètres › Message laissé."}
            </small>
          </FormGroup>
          {/* 04/11/2026 (registre n° 39) : échanges client */}
          <label style={{ fontWeight: "normal", display: "flex", gap: 8, alignItems: "center" }}>
            <input
              type="checkbox"
              checked={this.state.enLigne}
              onChange={(e) => this.setState({ enLigne: e.target.checked })}
            />
            Proposer au client de répondre en ligne (bouton « Répondre en ligne » dans le mail, photos possibles)
          </label>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={onCancel} disabled={sending}>
            Annuler
          </Button>
          <Button
            bsStyle="primary"
            disabled={sending}
            onClick={() => onConfirm(this.state.message, this.state.enLigne)}
          >
            <span className="fa fa-envelope" />
            &nbsp;{sending ? "Envoi…" : "Marquer « Message laissé » et envoyer le mail"}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/Modal/CallDoneModal.js